// Set 8:00 to 19:00 during the whole week as core working hours (including weekends)
// Uses user's local timezone - no need to handle daylight saving time manually
// as the browser automatically handles it for the user's location
export const isCoreHours = () => {
    const hour = new Date().getHours();
    return hour >= 8 && hour <= 18;
};

export const isOutOfCoreHours = () => !isCoreHours();
